import CreditCardProvider from "./enums/CreditCardProvider.js";
import {TariffId} from "./nominalTypes/TariffId";
import {ZoneId} from "./nominalTypes/ZoneId";
import {IntegraHolderData} from "./types/IntegraHolderData";
import {ParkingTariff} from "./types/ParkingTariff.js";
import {PaymentProvider} from "./types/PaymentProvider.js";

class Tariffs {
	static get(value: IntegraHolderData, tariffId: TariffId): ParkingTariff {
		let tariff = value.tariffs.find((x) => x.type === tariffId);
		if (tariff != null) {
			return tariff;
		}

		return {
			title: tariffId,
			description: ["—"],
			type: tariffId,
			zoneIds: [],
			cancellable: false,
			selectable: false
		}
	}

	static getAll(value: IntegraHolderData, tariffIds: TariffId[]): ParkingTariff[] {
		return tariffIds.map(t => this.get(value, t));
	}

	static getByZone(value: IntegraHolderData, zoneId: ZoneId): ParkingTariff[] {
		return value.tariffs.filter(x => x.zoneIds.includes(zoneId));
	}

	static getZones(value: IntegraHolderData, tariffId: TariffId): ZoneId[] {
		const current = value.tariffs.find((x) => x.type === tariffId);
		if (current == null) {
			return [];
		}

		return current.zoneIds;
	}

	static getPaymentProvider(value: IntegraHolderData, creditCardProvider: CreditCardProvider): PaymentProvider | undefined {
		let selected = creditCardProvider || value.paymentProviders?.creditCardProvider;
		return selected == null ? undefined : value.paymentProviders?.providers.find((x) => x.id === selected);
	}
}

export {Tariffs};
